import { BackIcon } from "../Icons/BackIcon";

export function NavigateBackButton(props: { onClick: () => void, label: string }) {
  return <button className="text-left hover:text-blue-500 mb-2 flex items-center" onClick={props.onClick}>
    <BackIcon/><span className="ml-2 text-base font-medium">{props.label}</span>
  </button>;
}
